module.exports = __webpack_public_path__ + "img/dk.caa90649.svg";